/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    object, func, string, shape,
} from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core';

const styles = (theme) => ({
    container: {
        width: '100%',
    },
    tabsWrapper: {
        maxHeight: 60,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: 10,
        [theme.breakpoints.down('sm')]: {
            paddingTop: 0,
            height: 30,
            justifyContent: 'space-around',
        },
    },
    tabsWrapperReview: {
        maxHeight: 60,
        display: 'flex',
        alignItems: 'center',
        marginTop: 10,
        [theme.breakpoints.down('sm')]: {
            paddingTop: 0,
            height: 30,
            justifyContent: 'space-around',
        },
    },
    selectTemplate: {
        [theme.breakpoints.down('xs')]: {
            fontSize: 0,
            '&::after': {
                content: '"Select"',
                fontSize: 25,
            },
        },
    },
    selectTab: {
        fontWeight: 'bold',
        lineHeight: '21px',
        textTransform: 'capitalize',
        padding: '10px 15px',
    },
    tab: {
        color: theme.palette.cgc?.bgTextOverlay1 || 'rgba(0,0,0,0.6)',
        textTransform: 'capitalize',
        padding: '0px 15px',
        [theme.breakpoints.down('xs')]: {
            padding: 0,
        },
    },
    personalizeCard: {
        [theme.breakpoints.down('xs')]: {
            fontSize: 0,
            '&::after': {
                content: '"Personalize"',
                fontSize: 25,

            },
        },
    },
    reviewCard: {
        [theme.breakpoints.down('xs')]: {
            fontSize: 0,
            '&::after': {
                content: '"Review"',
                fontSize: 25,

            },
        },
    },
});

const CelebrationsCustomModalNav = ({
    classes, setCustomView, modalViews, selectedView, selectedCard, messageData, customType, handlePersonalize,
}) => {
    const customName = customType === 'label' ? 'Label' : 'Hangtag';
    const personalizeDisabled = !(selectedCard.length > 0);
    const reviewDisabled = !(messageData?.text?.length > 0);
    return (
        <Grid className={classes.container}>
            <Grid item xs={12} className={classes.tabsWrapper}>
                <Grid>
                    <Button
                        className={`${classes.selectTemplate} ${selectedView === modalViews.SELECT_TEMPLATE ? classes.selectTab : classes.tab}`}
                        onClick={() => setCustomView(modalViews.SELECT_TEMPLATE)}
                    >
                        {`Select a ${customName}`}
                    </Button>
                </Grid>
                <Grid className={selectedView === modalViews.PERSONALIZE ? classes.selectTab : classes.tab}>
                    <Button
                        className={`${classes.personalizeCard} ${selectedView === modalViews.PERSONALIZE ? classes.selectTab : classes.tab}`}
                        onClick={() => setCustomView(modalViews.PERSONALIZE)}
                        disabled={personalizeDisabled}
                    >{`Customize ${customName}`}
                    </Button>
                </Grid>
                <Grid className={selectedView === modalViews.REVIEW ? classes.selectTab : classes.tab}>
                    <Button
                        className={`${classes.reviewCard} ${selectedView === modalViews.REVIEW ? classes.selectTab : classes.tab}`}
                        onClick={() => {
                            setCustomView(modalViews.REVIEW);
                            handlePersonalize();
                        }}
                        disabled={reviewDisabled}
                    >
                        {`Review ${customName}`}
                    </Button>
                </Grid>
            </Grid>
        </Grid>
    );
};

CelebrationsCustomModalNav.propTypes = {
    classes: object.isRequired,
    setCustomView: func.isRequired,
    modalViews: shape({
        PERSONALIZE: string,
        REVIEW: string,
    }).isRequired,
    selectedView: string.isRequired,
    selectedCard: string.isRequired,
    messageData: shape({
        text: string,
    }).isRequired,
    customType: string.isRequired,
    handlePersonalize: func.isRequired,
};

export default withStyles(styles)(CelebrationsCustomModalNav);
